import { ORDER_DETAILS_ENDPOINT } from '@yme/common/endpoints';
import { DEFAULT_COUNTRY_CODE, DEFAULT_LANGUAGE_CODE } from '@yme/services/i18n';
import { Network } from '@yme/services/network';
const defaultLocale = `${DEFAULT_LANGUAGE_CODE}_${DEFAULT_COUNTRY_CODE}`;
export const postOrderDetails = async (orderNumber, email, commercetoolsProject, locale) => {
    const { data } = await Network.post(ORDER_DETAILS_ENDPOINT, {
        orderNumber,
        email,
        commercetoolsProject,
        locale: locale || defaultLocale,
    });
    return data;
};
